/**
 * Unauthenticated, public-facing surfaces (donor giving pages, public bulletins,
 * prayer/join/event pages). Internal sync telemetry must never render here —
 * a donor on /public/:slug/give has no use for "No queued actions" and the
 * banner was observed covering the Fund dropdown at small viewports
 * (UX audit 2026-06-10, task 1.2).
 */
const PUBLIC_SURFACE_PREFIXES = ["/public", "/b/"];

export function isPublicSurfaceRoute(pathname: string) {
  return PUBLIC_SURFACE_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(prefix)
  );
}
